import { type HandledError, handleQueryError } from '@/shared/utils/helpers/handle-query-error';

import type { TLoginError } from '../../store/types';

export const handleLoginError = (error?: HandledError): TLoginError | undefined => {
  const queryError = handleQueryError(error);

  if (queryError) {
    if (typeof queryError === 'string') {
      return {
        root: queryError
      };
    }

    const { detail } = queryError;

    if (typeof detail === 'string') {
      const errors: TLoginError = {};
      switch (detail) {
        case 'User not found':
          errors.login = 'Пользователь не найден'
          break;
        default:
          errors.root = detail;
      }

      return errors;
    }

    if (Array.isArray(detail)) {
      const errors: TLoginError = {};
      detail.forEach((err) => {
        const location = err.loc?.[1];
        const message = err.msg;
        switch (location) {
          case 'login':
            errors.login = message;
            break;
          default:
            errors.root = message;
        }
      });

      return errors;
    }

    return {
      root: 'Unknown error',
    };
  }
};
